export const VOLUMEBAR_WIDTH = 76
